@if (isShowing()) {
    @if (data().length === 0) {
        <ion-skeleton-text class="w-100" />
    }
    @else {
        @for (d of data(); track d.urlKey) {
            <a target="_blank" [href]="d.urlKey" (click)="sendEvent(d)">
                <img 
                    class="w-100" 
                    loading="lazy"
                    [src]="d.image" 
                    [alt]="d.postTitle" 
                    (load)="viewBanner(d.guid, d.postTitle)"
                />
            </a>   
        }
    }
}
